import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from 'shared/atoms/Radio';
import Input from 'shared/atoms/Input';

import theme from 'shared/themes/default';

const AnswerRadioStyled = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: ${theme.spacing.s};
`;

const AnswerRadio = ({
  answer,
  disabled,
  index,
  name,
  onChangeAnswer,
  onChangeSelected,
  selected,
  selectedLanguage,
  theme: themeLayout,
}) => {
  let selectedColor;

  if (themeLayout === 'light') {
    selectedColor = theme.palette.mainDark;
  } else {
    selectedColor = theme.palette.lightPure;
  }

  const sxRadio = {
    padding: theme.spacing.xs,
    color:
      themeLayout === 'dark' ? theme.palette.lightPure : theme.palette.mainDark,
    '&.Mui-checked': {
      color: selectedColor,
    },
    '&.Mui-disabled': {
      color:
        themeLayout === 'dark'
          ? theme.palette.disabledDark
          : theme.palette.disabledLight,
    },
    '&:hover, &:focus, &:active': {
      color:
        themeLayout === 'dark' ? theme.palette.brand : theme.palette.mainDark,
    },
  };

  const handleChangeAnswer = (e) => {
    onChangeAnswer(index, e.target.value);
  };

  const handleChangeSelected = () => {
    onChangeSelected(index);
  };

  const answerTranslation = answer.find(
    (a) => a.languageCode === selectedLanguage
  );
  const translatedAnswer = answerTranslation?.value || '';

  return (
    <AnswerRadioStyled>
      <FormControlLabel
        control={
          <Radio
            checked={selected}
            disabled={disabled}
            name={name}
            onChange={handleChangeSelected}
            sx={sxRadio}
            value={index}
          />
        }
      />
      <Input
        disabled={disabled}
        fullWidth
        maxRows={4}
        multiline
        onChange={handleChangeAnswer}
        sx={{ marginLeft: '42px' /* Fix width to align with the top label */ }}
        value={translatedAnswer}
      />
    </AnswerRadioStyled>
  );
};

AnswerRadio.propTypes = {
  disabled: PropTypes.bool,
  theme: PropTypes.string,
  index: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  answer: PropTypes.array.isRequired,
  onChangeAnswer: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  selectedLanguage: PropTypes.string.isRequired,
  onChangeSelected: PropTypes.func.isRequired,
};

AnswerRadio.defaultProps = {
  theme: 'light',
};

export default AnswerRadio;
